import React from "react"
import { Link } from "gatsby"

export default ({ projects, pageContext }) => (
  <React.Fragment>
    <h2>Projects</h2>
    {projects.map(({ node }) => (
      <div key={node.fields.slug}>
        <h3 style={{ margin: 0 }}>
          <Link to={`projects/${node.fields.slug}`}>
            {node.frontmatter.title}
          </Link>
        </h3>
        <p dangerouslySetInnerHTML={{ __html: node.excerpt }} />
      </div>
    ))}
  </React.Fragment>
)
